import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        bookkeeping: {
          header: 'HEADER',
          aasm_state: {
            new_plan: 'AASM_NEW_PLAN',
            approved: 'AASM_APPROVED',
            paid: 'AASM_PAID',
            in_process: 'AASM_IN_PROCESS',
            can_be_process: 'AASM_CAN_BE_PROCESS',
          },
          transfer_payment_statuses: {
            default_payment: 'TRANSFER_PAYMENT_DEFAULT_PAYMENT',
            paid_in_next_month: 'TRANSFER_PAYMENT_PAID_IN_NEXT_MONTH',
          },
          bookkeeping_month_report: {
            back: 'MONTH_REPORT_BACK',
            paid: 'MONTH_REPORT_PAID',
            approved: 'MONTH_REPORT_APPROVED',
            download_report: 'MONTH_REPORT_DOWNLOAD_REPORT',
            transfer_payout: 'MONTH_REPORT_TRANSFER_PAYOUT',
            cancel_transfer_payout: 'MONTH_REPORT_CANCEL_TRANSFER_PAYOUT',
            transfer_payoff_to_balance: 'MONTH_REPORT_TRANSFER_PAYOFF',
            no_choosed_affiliates: 'MONTH_REPORT_NO_CHOSEN_AFFILIIATES',
            close_month_available_description: 'MONTH_REPORT_CLOSE_MONTH_DESCRIPTION',
            modal_window: {
              goal_approved: 'MONTH_REPORT_GOAL_APPROVED',
              goal_paid: 'MONTH_REPORT_GOAL_PAID',
              close: 'MONTH_REPORT_CLOSE',
              cancel: 'MONTH_REPORT_CANCEL',
              answer_yes: 'MONTH_REPORT_YES',
              answer_no: 'MONTH_REPORT_NO',
              change: 'MONTH_REPORT_CHANGE',
              change_question: 'MONTH_REPORT_CHANGE_QUESTION',
            },
            deduction: {
              form: {
                affiliate: 'DEDUCTION_FORM_AFFILIATE',
                deduction_size: 'DEDUCTION_FORM_SIZE',
                deduction_comment: 'DEDUCTION_FORM_COMMENT',
              },
              save: 'DEDUCTION_FORM_SAVE',
              delete: 'DEDUCTION_FORM_DELETE',
              back: 'DEDUCTION_FORM_BACK',
              edit_deduction: 'DEDUCTION_FORM_EDIT_DEDUCTION',
              create_deduction: 'DEDUCTION_FORM_CREATE_DEDUCTION',
            },
          },
        },
      },
    },
  }));
}
